export default "__VITE_ASSET__DunoQEEL__"